"use client";

import type { ReactNode } from "react";
import { useState } from "react";

import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";

export function AppShell({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="app-shell" data-collapsed={collapsed}>
      <Sidebar collapsed={collapsed} />
      <div className="shell-main">
        <Topbar collapsed={collapsed} onToggle={() => setCollapsed((value) => !value)} />
        <main className="page-canvas">{children}</main>
      </div>
    </div>
  );
}
